import React, { useContext } from "react";
import "./index.css";
import heartBeatIcon from "./icons/heartbeat.png";
import calenderIcon from "./icons/calendar.png";
import profile from "./icons/profile.png";
import profile1 from "./icons/profile1.png";
import settingIcon from "./icons/setting.png";
import { Link, NavLink } from "react-router-dom";
import stethoscopeIcon from "./icons/stethoscope.png";
import pharmacyIcon from "./icons/medicine.png";
import orderIcon from "./icons/shopping-bag.png";
import favoriteIcon from "./icons/heart.png";
// import UserContext from "../../../context/userContext";
import IconButton from "@mui/material/IconButton";
import Drawer from "@mui/material/Drawer";
import MenuIcon from "@mui/icons-material/Menu";
import Box from "@mui/material/Box";
import Footer from "../Footer";

const drawerWidth = 80;

export const PatientSidebar = (props) => {
  // let userValue = useContext(UserContext);
  let { user_id, user_type } = { user_id: "1", user_type: 2 };
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <div className="patientSidebar">
      <div>
        <NavLink
          to="/patient-dashboard"
          className={({ isActive }) => (isActive ? "patientDashboardIcon" : "")}
        >
          <div>
            <img
              src={heartBeatIcon}
              alt="heart icon"
              className="patinetHeartIcon"
            />
          </div>
        </NavLink>
        <NavLink
          to="/appointments"
          className={({ isActive }) => (isActive ? "patientDashboardIcon" : "")}
        >
          <div>
            <img
              src={calenderIcon}
              alt="calendar icon"
              className="patientCalenderIcon"
            />
          </div>
        </NavLink>
        <NavLink
          to="doctors"
          className={({ isActive }) => (isActive ? "patientDashboardIcon" : "")}
        >
          <div>
            <img src={stethoscopeIcon} className="patientProfile1Icon" />
          </div>
        </NavLink>
        <NavLink
          to="patient-profile"
          className={({ isActive }) => (isActive ? "patientDashboardIcon" : "")}
        >
          <div>
            <img src={profile} className="patinetProfileIcon" />
          </div>
        </NavLink>
        {/* <NavLink
          to="pharmacies"
          className={({ isActive }) => (isActive ? "patientDashboardIcon" : "")}
        >
          <div>
            <img src={pharmacyIcon} className="patinetProfileIcon" />
          </div>
        </NavLink>
        <NavLink
          to="orders"
          className={({ isActive }) => (isActive ? "patientDashboardIcon" : "")}
        >
          <div>
            <img src={orderIcon} className="patinetProfileIcon" />
          </div>
        </NavLink> */}
        <NavLink
          to="favourites"
          className={({ isActive }) => (isActive ? "patientDashboardIcon" : "")}
        >
          <div>
            <img src={favoriteIcon} className="patinetProfileIcon" />
          </div>
        </NavLink>
        <NavLink
          to="patient-settings"
          className={({ isActive }) =>
            isActive ? "dashboardIconSetting" : "settingIcon"
          }
        >
          <div>
            <img src={settingIcon} alt="setting" />
          </div>
        </NavLink>
      </div>
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;
  return (
    <>
      {/* Patient Sidebar */}
      <div style={{ backgroundColor: "#fff" }}>
        <IconButton
          color="inherit"
          className="sidebar-icon"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{
            display: { sm: "block", lg: "none" },
            marginTop: "-3px",
            marginLeft: "-2px",
            position: "fixed",
            // backgroundColor:"red"
          }}
        >
          <MenuIcon />
        </IconButton>
      </div>
      <Box
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", lg: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", lg: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
    </>
  );
};
